import React, {useEffect, useState} from "react";
import {useNavigate, Link} from "react-router-dom";
import TimeOutModal from "../Assets/TimeOutModal";
import {Trans, useTranslation} from "react-i18next";
import {Col, Alert, Form, FormFeedback, FormGroup, Input, Label, Row} from "reactstrap";
import BreadCrumb from "../Layout/BreadCrumb";
import Item from "../Assets/Item";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

var serialize = require('serialize-javascript');
function Consequences (props) {
    // fetch data from local Storage
    let history = useNavigate();
const [d, setDead] = useState()
    const { i18n } = useTranslation();
    const [isLoading, setIsLoading ]= useState()

    const next = () =>{
        let nextLocation ={}
        if (d){
            nextLocation = {
                pathname: '../physicald',
                state: { d: d }
            }
        }else{
            nextLocation = {
                pathname: '../physical',
                state: { d: d }
            }
        }

        history(nextLocation)
    }

    const handleNext = (e) =>{
        e.preventDefault()
        next()
    }

    const prevLocation = {
        pathname: '../circumstances',
        state: { d: d }
    }
    const handlePrev = (e) =>{
        e.preventDefault()
        history(prevLocation)
    }

    const [stored, setStored] =  useState("")
    const [Age, setAge]= useState(localStorage.getItem("Age"))

    useEffect(() => {
                    window.scrollTo(0, 0)
        const fetchData = async () => {
            setIsLoading(true);
            const dead = localStorage.getItem('isDead')
            //console.log(dead)
            dead === "true" ? setDead(true) : setDead(false)
            setIsLoading(false);

            const item = JSON.parse(localStorage.getItem('item'))
            const consequences = JSON.parse(localStorage.getItem('consequences'))

            setFieldHasConsequences("no")
            if (item && item[0]){
                setStored(true)

                setItem(item)
                setNumber(item.length)
                setFieldHasConsequences("yes")
              //console.log(Number)

            }
        };
        fetchData()
    }, []);

    const [Number, setNumber] = useState(0)
    const addItem = (e) => {
        e.preventDefault()
        setNumber(Number+1)
        //console.log(item)
    }

    const [Field50Consequences, setField50Consequences] = useState("");
    //  Input radio change
    const handleChangeField50Consequences = (e) => {
        let value = e.target.value
        setField50Consequences(value);
    }

    const [checkbox, setCheckbox] = useState({});
    const handleChangeCheckbox = (e) => {
        let itemName = e.target.name;
        const isChecked = e.target.checked;
        let partialChecked = {...checkbox}
        partialChecked[itemName] = isChecked
        setCheckbox( partialChecked )
      //console.log(checkbox)
    }

    const [FieldHasConsequences, setFieldHasConsequences] = useState((""));
    const handleChangeFieldHasConsequences = (e) => {
        let value = e.target.value
        setFieldHasConsequences(value);
    }
    const [itemFormOk, setItemFormOk] = useState()
    const [item, setItem] = useState([])
    const submitItem = (itemIndex, itemObject) => {
      //console.log(itemIndex)
        //console.log(itemObject)
        //console.log(item)
        let cArray = item
        if (cArray[itemIndex]){cArray[itemIndex] = itemObject}else{cArray.push(itemObject)}
      //console.log(cArray)
        let itemp = serialize(cArray , {isJSON:true})
        //console.log(itemp)
        localStorage.setItem("item", itemp)
        setStored(true)
        setItem(cArray)
        setItemFormOk(true)
        let consequences = {
            Number : Number
        }
        //let stringInfo = JSON.stringify(consequences)
        let stringInfo = serialize(consequences, {isJSON: true});
        localStorage.setItem("consequences" , stringInfo)
    }

    const deleteItem = ( itemIndex) => {
      //console.log(itemIndex)
      //console.log(item)
        let cArray = item
        cArray.splice(itemIndex,1)

      //console.log(cArray)
        let itemp = serialize(cArray , {isJSON:true})
        //console.log(itemp)
        localStorage.setItem("item", itemp)
        if (Number > 0 ){
            setNumber(Number-1)
        }
        setItem(cArray)
        let consequences = {
            Number : Number,
            FieldHasConsequences : FieldHasConsequences
        }
        //let stringInfo = JSON.stringify(consequences)
        let stringInfo = serialize(consequences, {isJSON: true});
        localStorage.setItem("consequences" , stringInfo)
    }

    // Submit and validation
    const [NotValid, setNotValid] = useState(false)

    const handleSubmit = (evt) => {

                    window.scrollTo(0, 0)
        evt.preventDefault();


        //console.log(JSON.parse(stringInfo))
        next()

    }

    const itemForms = []
    for (let i= 0; i < Number; i++){
        itemForms.push(<Item i18n={i18n} key={i} index={i} d={d} delete={deleteItem} submitItem={submitItem} />)
    }

    return (
        <div className={d? "death" : "injured"}>
            { !!isLoading ? (
                    <div className={'text-center pt-5'}><img className={'d-inline-block'} src="/accidentinfo/spinner.svg" alt=""/></div>
                ) :
                <div className={"container"}>
                    <TimeOutModal i18n={i18n} />
                    {(Age < 16)?
                        <BreadCrumb n={5}/> : <BreadCrumb n={6}/>}
                    <Row>
                        <Col>

                            <h3>{ d? i18n.t("CONSEQUENCESTITLE"): i18n.t("CONSEQUENCESTITLE") }</h3>
                            <h4 className={"text-primary"}>{  d? i18n.t("Les conséquences matérielles"): i18n.t("Les conséquences matérielles") }</h4>
                            { NotValid &&
                            <div className="alert alert-danger">
                                <button type="button" className="close" data-dismiss="alert" aria-hidden="true">×</button>
                                <FontAwesomeIcon className="pre" icon={['fas', 'hand-point-right']} /> <strong>{  i18n.t('Erreur(s) dans votre formulaire') }</strong>
                                <hr className="message-inner-separator"/>
                                <p>{i18n.t('Merci de vérifier les champs indiqués en rouge')}</p>
                            </div>
                            }

                            <Form>
                                <div className="formlevel01">
                                    <FormGroup>
                                        <Label for="Field50Consequences" className={(NotValid && Field50Consequences === "") ? "text-danger" : "text"}>{d? i18n.t("Le défunt a-t-il subi des dommages à des objets autres qu’au véhicule ?") : i18n.t("Avez-vous subi des dommages à des objets autres qu’au véhicule ?")} <span className={"text-danger"}>*</span></Label>
                                       <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="FieldHasConsequences"  onChange={handleChangeFieldHasConsequences} value="no"
                                                           checked={(FieldHasConsequences === "no") }/> {i18n.t("NO")}
                                                </Label>
                                            </div>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="FieldHasConsequences"  onChange={handleChangeFieldHasConsequences} value="yes"
                                                           checked={(FieldHasConsequences === "yes") }/> {i18n.t("YES")}
                                                </Label>
                                            </div>
                                            {(NotValid && FieldHasConsequences === "") && <span className="help-block form-error">{i18n.t("Obligatoire")}</span>}


                                        {itemForms}
                                    </FormGroup>
                                    <div>
                                        {(FieldHasConsequences === "yes" ) &&
                                        <div className="text-start">
                                            <button type="submit"  onClick={addItem} className="btn btn-outline small"><FontAwesomeIcon className="pre" icon={['fas', 'plus']} />{  i18n.t("AJOUTER UN DOMMAGE") }</button>
                                        </div>
                                        }
                                    </div>
                                    {(Object.entries(item).length === Number || itemFormOk) &&
                                    <div className="button-wrapper">
                                        <button type="submit"  onClick={handleNext} className="btn btn-primary small">{ !stored ?  i18n.t('Enregistrer') : i18n.t('Mettre à jour') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                    </div>}


                                </div>
                            </Form>

                            <span className={"text-danger"}>*</span> {  i18n.t('Renseignement indispensable') }<br />
                        </Col>
                    </Row>
                    
                </div>}
        </div>
    )
}
export default Consequences

